import React from 'react'
import { Button, Icon, Progress, Upload } from 'antd'

import { getAcceptedAttribute } from '../../utils'
import './ReferenceRequestCard.scss'

const getReferenceUploadBusyKey = (phase, request = {}) =>
  `reference:${phase}:${request.id || request.name || 'entity'}`

const ReferenceRequestCard = ({
  phase,
  referenceRequest,
  acceptedExtensions,
  phaseBusyAction,
  uploadProgress,
  uploadStatus,
  uploadMessage,
  onUploadReference
}) => {
  if (!referenceRequest) return null

  const entityName = referenceRequest.name || 'this item'
  const busyKey = getReferenceUploadBusyKey(phase, referenceRequest)
  const isUploading = phaseBusyAction === busyKey
  const isBusy = Boolean(phaseBusyAction)
  const hasUploadPath = Boolean(
    referenceRequest.upload_path || referenceRequest.uploadPath
  )
  const progressPercent = isUploading
    ? Math.max(1, Number(uploadProgress || 0))
    : 0
  const handleBeforeUpload = (file, fileList = []) => {
    const selectedFiles = fileList.length ? fileList : [file]
    const firstFile = selectedFiles[0]

    if (firstFile && firstFile.uid && firstFile.uid !== file.uid) {
      return false
    }

    if (firstFile && !firstFile.uid && firstFile !== file) {
      return false
    }

    onUploadReference(phase, referenceRequest, selectedFiles)
    return false
  }

  return (
    <div className="creative-direction-chat__reference-request">
      <div className="creative-direction-chat__reference-request-icon">
        <Icon type="paper-clip" />
      </div>
      <div className="creative-direction-chat__reference-request-copy">
        <span>Reference requested</span>
        <strong>{`Upload reference for ${entityName}`}</strong>
        <p>
          The AI asked for a visual reference before it continues this phase.
          Upload one or more images or videos here so they are attached to the
          right item.
        </p>
        {isUploading ? (
          <div className="creative-direction-chat__reference-progress">
            <Progress
              percent={progressPercent}
              size="small"
              status={uploadStatus === 'failed' ? 'exception' : 'active'}
              showInfo
            />
            {uploadMessage ? <small>{uploadMessage}</small> : null}
          </div>
        ) : null}
      </div>
      <Upload
        accept={getAcceptedAttribute(acceptedExtensions)}
        multiple
        showUploadList={false}
        beforeUpload={handleBeforeUpload}
        disabled={isBusy || !onUploadReference || !hasUploadPath}
      >
        <Button
          type="primary"
          icon="upload"
          loading={isUploading}
          disabled={isBusy || !onUploadReference || !hasUploadPath}
        >
          {isUploading ? 'Uploading' : `Upload ${entityName} references`}
        </Button>
      </Upload>
    </div>
  )
}

export default ReferenceRequestCard
